/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
import Chart from 'react-apexcharts';
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  Paper,
  ButtonBase,
  styled
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import ArrowRightIcon from '../../icons/ArrowRight';
import { campaignApi } from '../../api/campaignApi';
import { useCallback, useState, useEffect } from 'react';
import useMounted from '../../hooks/useMounted';
import * as moment from 'moment';
import useAuth from '../../hooks/useAuth';
import DeleteIcon from '@mui/icons-material/Delete';
import toast from 'react-hot-toast';
import FormationResultTable from '../dashboard/formation/FormationResultTable';
import CampaignResultTable from './CampaignResultTable';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewListIcon from '@mui/icons-material/ViewList';

const professions = [
  'Médecin', 'Pédicure-podologue', 'Sage-Femme', 'Infirmier', 'Masseur-kinésithérapeute', 'Pharmacien'
];

const sortOptions = [
  {
    label: 'Pas de tri',
    value: 'default'
  },
  {
    label: 'Nom (A - Z)',
    value: 'name|asc'
  },
  {
    label: 'Nom (Z - A)',
    value: 'name|desc'
  },
  {
    label: 'Progression croissant',
    value: 'progression|asc'
  },
  {
    label: 'Progression décroissant',
    value: 'progression|desc'
  },
  {
    label: 'Date de début croissant',
    value: 'startDate|asc'
  },
  {
    label: 'Date de début décroissant',
    value: 'startDate|desc'
  },
  {
    label: 'Date de fin croissant',
    value: 'endDate|asc'
  },
  {
    label: 'Date de fin décroissant',
    value: 'endDate|desc'
  }
];

const typeOptions = [
  {
    label: 'Tous',
    value: 'all'
  },
  {
    label: 'Campagnes',
    value: 'campaigns'
  },
  {
    label: 'Réinjections',
    value: 'reinjections'
  },
];

const CampaignStats = () => {
  const theme = useTheme();
  const mounted = useMounted();
  const { user } = useAuth();
  const [infoCampaign, setInfoCampaign] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [openDelete1, setOpenDelete1] = useState(false);
  const [campaignDelete, setCampaignDelete] = useState('');
  const [region, setRegion] = useState('all');
  const [profession, setProfession] = useState('Tous');
  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState([]);
  const [selectedProfession, setSelectedProfession] = useState([]);
  const [sort, setSort] = useState(sortOptions[0].value);
  const [type, setType] = useState(typeOptions[0].value);
  const [commercial, setCommercial] = useState([]);
  const [selectedCommercial, setSelectedCommercial] = useState([]);
  const [names, setNames] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [department, setDepartment] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [mode, setMode] = useState('list');
  const [isLoading, setIsLoading] = useState(true);

  const handleModeChange = (event, value) => {
    if (value !== null) {
      setMode(value);
    }
  };

  const dialogDelete = (index) => {
    setOpenDelete(true);
    setCampaignDelete(index);
  };

  const handleDeleteCampaign = async (index) => {
    try {
      await campaignApi.deleteCampaign(infoCampaign[index] !== undefined ? infoCampaign[campaignDelete].id : '', localStorage.getItem('accessToken'));
      const tempInfoCampaign = [...infoCampaign];
      tempInfoCampaign.splice(index, 1);
      setInfoCampaign(tempInfoCampaign);
      toast.success('Campagne supprimée !');
      setOpenDelete(false);
      setOpenDelete1(false);
    } catch (err) {
      console.error(err);
      toast.error('Erreur lors de la suppression de la campagne.');
    }
  };

  const getCampaign = useCallback(async () => {
    try {
      const data = await campaignApi.getCampaign(region, department, profession, sort, commercial, type, localStorage.getItem('accessToken'));
      if (data.length === 0) {
        throw new Error('La campagne n\'existe pas');
      }

      if (mounted.current) {
        setInfoCampaign(data.infoCampaign);
        setRegions(data.regionsList);
        setNames(data.names);
        setIsLoading(false);
      }
    } catch (err) {
      console.error(err);
    }
  }, [mounted, region, department, profession, sort, commercial, type]);

  useEffect(() => {
    getCampaign();
  }, [getCampaign]);

  const handleCampaigns = useCallback(async (regionChange, departmentChange, professionChange, sortChange, commercialChange, typeChange) => {
    try {
      setIsLoading(true);
      const data = await campaignApi.getCampaign(regionChange, departmentChange, professionChange, sortChange, commercialChange, typeChange, localStorage.getItem('accessToken'));
      setInfoCampaign(data.infoCampaign);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
    }
  }, []);

  const handleRegion = (value) => {
    setRegion(value);
    handleCampaigns(value, department, profession, sort, commercial, type);
  };

  const handleProfession = (value) => {
    setProfession(value);
    handleCampaigns(region, department, value, sort, commercial, type);
  };

  const handleSortChange = (event) => {
    setSort(event.target.value);
    handleCampaigns(region, department, profession, event.target.value, commercial, type);
  };
  const handleTypeChange = (event) => {
    setType(event.target.value);
    handleCampaigns(region, department, profession, sort, commercial, event.target.value);
  };
  const handleCommercial = (value) => {
    setCommercial(value);
    handleCampaigns(region, department, profession, sort, value, type);
  };

  const handleDepartement = (value) => {
    setDepartment(value);
    handleCampaigns(region, value, profession, sort, commercial, type);
  };

  const getDepartments = async () => {
    try {
      const departements = require('../../departments.json');
      setDepartments(departements);
      return true;
    } catch (err) {
      console.log(err);
      return err;
    }
  };

  useEffect(() => {
    getDepartments();
  }, []);

  const reinitializeFilters = () => {
    // on réinitialise les filtres
    setSort('default');
    setSelectedCommercial([]);
    setSelectedDepartments([]);
    setSelectedProfession([]);
    setSelectedRegion([]);
    setRegion([]);
    setDepartment([]);
    setProfession([]);
    setCommercial([]);
    setType('all');
    // on affiche les résultats réinitialisés
    handleCampaigns('all', [], 'Tous', 'default', [], 'all');
  };

  return (
    <Box>
      <Dialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
      >
        <DialogContent>
          <DialogContentText>
            {`Souhaitez-vous vraiment supprimer la campagne ${infoCampaign[campaignDelete] !== undefined ? infoCampaign[campaignDelete].name : ''} ?`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleDeleteCampaign(campaignDelete)}
            color="primary"
          >
            Supprimer
          </Button>
          <Button
            onClick={() => setOpenDelete(false)}
            color="primary"
          >
            Annuler
          </Button>
        </DialogActions>
      </Dialog>

      <Card
        sx={{
          p: 3,
          mb: 4,
          borderRadius: '24px',
          border: '1px solid rgba(226, 232, 240, 0.8)',
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.02), 0 8px 10px -6px rgba(0, 0, 0, 0.02)',
          backgroundColor: theme.palette.mode === 'light' ? '#ffffff' : 'background.paper',
        }}
      >
        <Grid container spacing={2.5} alignItems="center">
          {/* Row 1: Filters */}
          <Grid item xs={12} sm={6} md={user.access_level === 0 ? 3 : 4}>
            <Autocomplete
              fullWidth
              multiple
              id="tags-standard-region"
              options={regions}
              renderTags={(tagValue, getTagProps) => tagValue.map((option, index) => (
                <Chip
                  key={option.region}
                  label={option.region}
                  {...getTagProps({ index })}
                  sx={{
                    borderRadius: '8px',
                    backgroundColor: 'rgba(59, 130, 246, 0.08)',
                    color: '#3b82f6',
                    fontWeight: 500,
                  }}
                />
              ))}
              onChange={(event, newValue) => {
                handleRegion(newValue);
                setSelectedRegion([
                  ...newValue,
                ]);
              }}
              onUpdateInput={
                () => {
                  handleCampaigns('all', department, profession, sort, commercial, type);
                }
              }
              getOptionLabel={(option) => option.region}
              value={selectedRegion}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Régions"
                  placeholder="Sélectionner..."
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '14px',
                      backgroundColor: theme.palette.mode === 'light' ? '#ffffff' : 'transparent',
                      '& fieldset': {
                        borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.15)'
                      },
                      '&:hover fieldset': {
                        borderColor: 'rgba(59, 130, 246, 0.4)'
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#3b82f6',
                        boxShadow: '0 0 0 4px rgba(59, 130, 246, 0.1)'
                      }
                    }
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={user.access_level === 0 ? 3 : 4}>
            <Autocomplete
              fullWidth
              multiple
              id="tags-standard-department"
              options={departments}
              renderTags={(tagValue, getTagProps) => tagValue.map((option, index) => (
                <Chip
                  key={option.code}
                  label={option.nom}
                  {...getTagProps({ index })}
                  sx={{
                    borderRadius: '8px',
                    backgroundColor: 'rgba(59, 130, 246, 0.08)',
                    color: '#3b82f6',
                    fontWeight: 500,
                  }}
                />
              ))}
              onChange={(event, newValue) => {
                handleDepartement(newValue);
                setSelectedDepartments([
                  ...newValue,
                ]);
              }}
              onUpdateInput={
                () => {
                  handleCampaigns(region, 'Tous', profession, sort, commercial, type);
                }
              }
              getOptionLabel={(option) => `${option.code} - ${option.nom}`}
              value={selectedDepartments}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Départements"
                  placeholder="Sélectionner..."
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '14px',
                      backgroundColor: theme.palette.mode === 'light' ? '#ffffff' : 'transparent',
                      '& fieldset': {
                        borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.15)'
                      },
                      '&:hover fieldset': {
                        borderColor: 'rgba(59, 130, 246, 0.4)'
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#3b82f6',
                        boxShadow: '0 0 0 4px rgba(59, 130, 246, 0.1)'
                      }
                    }
                  }}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={user.access_level === 0 ? 3 : 4}>
            <Autocomplete
              fullWidth
              multiple
              id="tags-standard-profession"
              options={professions}
              renderTags={(tagValue, getTagProps) => tagValue.map((option, index) => (
                <Chip
                  key={option}
                  label={option}
                  {...getTagProps({ index })}
                  sx={{
                    borderRadius: '8px',
                    backgroundColor: 'rgba(59, 130, 246, 0.08)',
                    color: '#3b82f6',
                    fontWeight: 500,
                  }}
                />
              ))}
              onChange={(event, newValue) => {
                handleProfession(newValue);
                setSelectedProfession([
                  ...newValue,
                ]);
              }}
              onUpdateInput={
                () => {
                  handleCampaigns(region, department, 'Tous', sort, commercial, type);
                }
              }
              getOptionLabel={(option) => option}
              value={selectedProfession}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Professions"
                  placeholder="Sélectionner..."
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '14px',
                      backgroundColor: theme.palette.mode === 'light' ? '#ffffff' : 'transparent',
                      '& fieldset': {
                        borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.15)'
                      },
                      '&:hover fieldset': {
                        borderColor: 'rgba(59, 130, 246, 0.4)'
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#3b82f6',
                        boxShadow: '0 0 0 4px rgba(59, 130, 246, 0.1)'
                      }
                    }
                  }}
                />
              )}
            />
          </Grid>

          {user.access_level === 0 && (
            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                fullWidth
                multiple
                id="tags-standard-commercial"
                options={names}
                renderTags={(tagValue, getTagProps) => tagValue.map((option, index) => (
                  <Chip
                    key={option.name}
                    label={option.name}
                    {...getTagProps({ index })}
                    sx={{
                      borderRadius: '8px',
                      backgroundColor: 'rgba(59, 130, 246, 0.08)',
                      color: '#3b82f6',
                      fontWeight: 500,
                    }}
                  />
                ))}
                onChange={(event, newValue) => {
                  handleCommercial([
                    ...newValue,
                  ]);
                  setSelectedCommercial([
                    ...newValue,
                  ]);
                }}
                onUpdateInput={
                  () => {
                    handleCampaigns(region, department, profession, sort, 'Tous', type);
                  }
                }
                getOptionLabel={(option) => option.name}
                value={selectedCommercial}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Commerciaux"
                    placeholder="Sélectionner..."
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '14px',
                        backgroundColor: theme.palette.mode === 'light' ? '#ffffff' : 'transparent',
                        '& fieldset': {
                          borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.15)'
                        },
                        '&:hover fieldset': {
                          borderColor: 'rgba(59, 130, 246, 0.4)'
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#3b82f6',
                          boxShadow: '0 0 0 4px rgba(59, 130, 246, 0.1)'
                        }
                      }
                    }}
                  />
                )}
              />
            </Grid>
          )}

          {/* Row 2: Actions & View Switcher */}
          <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center" sx={{ mt: 1, flexWrap: 'wrap', gap: 2 }}>
            <Button
              onClick={reinitializeFilters}
              color="primary"
              variant="outlined"
              sx={{
                borderRadius: '12px',
                textTransform: 'none',
                fontWeight: 600,
                px: 3,
                py: 1,
                borderColor: 'rgba(59, 130, 246, 0.3)',
                color: '#3b82f6',
                '&:hover': {
                  borderColor: '#3b82f6',
                  backgroundColor: 'rgba(59, 130, 246, 0.04)',
                },
                transition: 'all 0.2s ease'
              }}
            >
              Réinitialiser les filtres
            </Button>

            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ToggleButtonGroup
                exclusive
                onChange={handleModeChange}
                size="small"
                value={mode}
                sx={{
                  backgroundColor: theme.palette.mode === 'light' ? '#f1f5f9' : 'rgba(255,255,255,0.05)',
                  padding: '4px',
                  borderRadius: '12px',
                  border: '1px solid rgba(226, 232, 240, 0.8)',
                  '& .MuiToggleButtonGroup-grouped': {
                    border: 0,
                    '&.Mui-disabled': {
                      border: 0,
                    },
                    '&:not(:first-of-type)': {
                      borderRadius: '8px',
                    },
                    '&:first-of-type': {
                      borderRadius: '8px',
                    },
                  },
                }}
              >
                <ToggleButton
                  value="list"
                  sx={{
                    px: 2.5,
                    py: 0.75,
                    textTransform: 'none',
                    fontWeight: 600,
                    color: mode === 'list' ? '#3b82f6' : 'text.secondary',
                    backgroundColor: mode === 'list' ? '#ffffff' : 'transparent',
                    boxShadow: mode === 'list' ? '0 1px 3px 0 rgba(0,0,0,0.1), 0 1px 2px -1px rgba(0,0,0,0.1)' : 'none',
                    '&:hover': {
                      backgroundColor: mode === 'list' ? '#ffffff' : 'rgba(0,0,0,0.04)',
                    },
                    '&.Mui-selected': {
                      color: '#3b82f6',
                      backgroundColor: '#ffffff',
                      '&:hover': {
                        backgroundColor: '#ffffff',
                      },
                    },
                  }}
                >
                  <ViewListIcon fontSize="small" sx={{ mr: 0.75 }} />
                  Liste
                </ToggleButton>
                <ToggleButton
                  value="grid"
                  sx={{
                    px: 2.5,
                    py: 0.75,
                    textTransform: 'none',
                    fontWeight: 600,
                    color: mode === 'grid' ? '#3b82f6' : 'text.secondary',
                    backgroundColor: mode === 'grid' ? '#ffffff' : 'transparent',
                    boxShadow: mode === 'grid' ? '0 1px 3px 0 rgba(0,0,0,0.1), 0 1px 2px -1px rgba(0,0,0,0.1)' : 'none',
                    '&:hover': {
                      backgroundColor: mode === 'grid' ? '#ffffff' : 'rgba(0,0,0,0.04)',
                    },
                    '&.Mui-selected': {
                      color: '#3b82f6',
                      backgroundColor: '#ffffff',
                      '&:hover': {
                        backgroundColor: '#ffffff',
                      },
                    },
                  }}
                >
                  <ViewModuleIcon fontSize="small" sx={{ mr: 0.75 }} />
                  Mosaïque
                </ToggleButton>
              </ToggleButtonGroup>
            </Box>
          </Grid>
        </Grid>
      </Card>

      {mode !== 'list' ? (
        <Grid container spacing={3}>
          {infoCampaign.map((info, index) => {
            const chartOptions = {
              chart: {
                background: 'transparent',
                stacked: false,
                toolbar: {
                  show: false
                }
              },
              colors: [info.progression > 0 ? '#7EB627' : '#94a3b8'],
              labels: [`${info.progression === null ? 0 : info.progression} %`],
              plotOptions: {
                radialBar: {
                  dataLabels: {
                    value: {
                      show: false
                    }
                  },
                  hollow: {
                    size: '60%'
                  },
                  track: {
                    background: theme.palette.mode === 'light' ? '#f1f5f9' : 'rgba(255,255,255,0.05)'
                  }
                }
              },
              theme: {
                mode: theme.palette.mode
              }
            };
            const chartSeries = [info.progression === null ? 0 : info.progression];
            let borderColor = '#7EB627';
            if (new Date() < new Date(info.start_date)) {
              borderColor = '#3b82f6';
            } else if (new Date() > new Date(info.end_date)) {
              borderColor = '#94a3b8';
            }
            return (
              <Grid
                item
                xs={12}
                md={6}
                lg={4}
                key={info.id || index}
                sx={{ display: 'flex' }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    borderRadius: '20px',
                    border: `1.5px solid ${borderColor}`,
                    backgroundColor: info.type === 'réinjection' && theme.palette.mode === 'light'
                      ? 'rgba(231, 255, 249, 0.4)'
                      : info.type === 'réinjection' && theme.palette.mode === 'dark'
                        ? '#1e293b'
                        : theme.palette.mode === 'light'
                          ? '#ffffff'
                          : '#1e293b',
                    boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05), 0 2px 4px -1px rgba(0,0,0,0.03)',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    overflow: 'hidden',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 12px 20px -8px rgba(0, 0, 0, 0.08), 0 4px 12px -2px rgba(0, 0, 0, 0.03)',
                    }
                  }}
                >
                  <CardContent
                    sx={{
                      p: 3,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 2,
                      flexGrow: 1
                    }}
                  >
                    <Box sx={{ width: 100, height: 100, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <Chart
                        options={chartOptions}
                        series={chartSeries}
                        type="radialBar"
                        height={120}
                        width={120}
                      />
                    </Box>

                    <Box sx={{ minWidth: 0, flexGrow: 1 }}>
                      <Typography
                        color="textPrimary"
                        variant="h6"
                        sx={{ fontWeight: 700, mb: 1, fontSize: '1.05rem', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}
                      >
                        {info.name}
                      </Typography>
                      <Typography
                        color="textSecondary"
                        variant="body2"
                        sx={{ mt: 0.5, fontSize: '0.85rem', lineHeight: 1.5 }}
                      >
                        Début : <strong>{moment(new Date(info.start_date)).format('DD/MM/YYYY')}</strong>
                        <br />
                        Fin : <strong>{moment(new Date(info.end_date)).format('DD/MM/YYYY')}</strong>
                      </Typography>
                    </Box>
                  </CardContent>

                  {user.access_level === 0 && (
                    <Box sx={{ px: 3, pb: 2 }}>
                      <Typography
                        color="textSecondary"
                        variant="body2"
                        sx={{ fontWeight: 500, fontSize: '0.85rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                      >
                        Commerciaux : <span style={{ color: theme.palette.text.primary, fontWeight: 600 }}>{info.commercials || 'Aucun'}</span>
                      </Typography>
                    </Box>
                  )}
                  <Divider sx={{ borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255,255,255,0.08)' }} />
                  <CardActions
                    disableSpacing
                    sx={{ px: 2, py: 1.5, display: 'flex', justifyContent: 'space-between', backgroundColor: theme.palette.mode === 'light' ? '#f8fafc' : 'rgba(255,255,255,0.02)' }}
                  >
                    <Button
                      component={RouterLink}
                      to={`/dashboard/campaign/${info.id}`}
                      color="primary"
                      endIcon={<ArrowRightIcon fontSize="small" />}
                      variant="text"
                      sx={{
                        textTransform: 'none',
                        fontWeight: 600,
                        borderRadius: '8px',
                        '&:hover': {
                          backgroundColor: 'rgba(59, 130, 246, 0.04)',
                        }
                      }}
                    >
                      Plus d&apos;informations
                    </Button>
                    <IconButton
                      disabled={user.access_level !== 0}
                      onClick={() => dialogDelete(index)}
                      sx={{
                        color: '#ef4444',
                        '&:hover': {
                          backgroundColor: 'rgba(239, 68, 68, 0.08)',
                        }
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </CardActions>
                </Paper>
              </Grid>
            );
          })}
        </Grid>
      ) : (
        <Grid container>
          <Grid item xs={12}>
            <CampaignResultTable
              infoCampaign={infoCampaign}
              setInfoCampaign={setInfoCampaign}
              handleDeleteCampaign={handleDeleteCampaign}
              campaignDelete={campaignDelete}
              setCampaignDelete={setCampaignDelete}
              openDelete1={openDelete1}
              setOpenDelete1={setOpenDelete1}
              isLoading={isLoading}
            />
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default CampaignStats;
